export const ROUTER_PATH = {
  home: "/",
  preview: {
    pdf: "/preview/pdf",
  },
  auth: {
    _path: "/auth",
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    findPassword: "/auth/find-password",
  },
  document: {
    archive: {
      _path: "/document/archives",
      create: {
        _path: "/document/archives/create",
        form: (uuid?: string) =>
          `/document/archives/create/${uuid ? uuid : ":uuid"}`,
      },
      dashboard: "/document/archives/dashboard",
      detail: (id?: string) => `/document/archives/${id ?? ":id"}`,
    },
    analysis: {
      _path: "/document/analysis",
      create: {
        _path: "/document/analysis/create",
        form: (uuid?: string) =>
          `/document/analysis/create/form/${uuid ? uuid : ":uuid"}`,
      },
      dashboard: "/document/analysis/dashboard",
      detail: (uuid?: string) => `/document/analysis/${uuid ?? ":uuid"}`,
    },
    work: {
      _path: "/document/work",
      create: {
        _path: "/document/work/create",
        form: (uuid?: string) =>
          `/document/work/create/${uuid ? uuid : ":uuid"}`,
      },
      dashboard: "/document/work/dashboard",
      detail: (uuid?: string) => `/document/work/${uuid ?? ":uuid"}`,
    },
  },
  myPage: {
    information: "/my-page/information",
    payment: "/my-page/payment",
    desk: "/my-page/desk",
  },
  tag: {
    create: "/tag/create",
    dashboard: {
      _path: "/tag/dashboard",
      detail: {
        _path: (id?: string) => `/tag/dashboard/${id ?? ":id"}`,
        edit: (id?: string) => `/tag/dashboard/${id ?? ":id"}/edit`,
      },
    },
  },
  user: {
    dashboard: {
      _path: "/user/dashboard",
      detail: (id?: string) => `/user/dashboard/${id ?? ":id"}`,
    },
  },
  notice: {
    create: "/notice/create",
    dashboard: {
      _path: "/notice/dashboard",
      detail: (id?: string) => `/notice/dashboard/${id ?? ":id"}`,
      edit: (id?: string) => `/notice/dashboard/${id ?? ":id"}/edit`,
    },
  },
  policy: {
    terms_of_service: {
      _path: "/policy/terms_of_service",
    },
    privacy_policy: {
      _path: "/policy/privacy_policy",
    },
  },
  pushNotification: {
    _path: "/push-notification",
  },
};
